import { createSlice } from '@reduxjs/toolkit';
import { initialState, commonReducers } from './fileVersionHistory.slice';

const techSpecsVersionHistorySlice = createSlice({
  name: 'techSpecsVersionHistory',
  initialState,
  reducers: { ...commonReducers },
});

export default techSpecsVersionHistorySlice.reducer;
export const {
  setOpenFileVersionHistory,
  setOpenDeleteVersionConfirmationModal,
  addToFileVersions,
  getNextVersions,
  deletedLastVersion,
} = techSpecsVersionHistorySlice.actions;
